import { render, staticRenderFns } from "./work-grid.vue?vue&type=template&id=faca87f2"
import script from "./work-grid.vue?vue&type=script&lang=js"
export * from "./work-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports